<h2 mat-dialog-title>Enviar WhatsApp{{ data?.context ? ' - ' + data.context : '' }}</h2>
<div mat-dialog-content class="whatsapp-edit">
  <form [formGroup]="form">
    <div>
      <label>Para</label>
      <input formControlName="to" placeholder="Número ou destinatário" />
    </div>

    <div>
      <div style="display:flex; align-items:center; gap:8px;">
        <label>Mensagem</label>
        <button mat-icon-button type="button" color="primary"
                matTooltip="Consultar Texto Adicional"
                (click)="toggleTxtAddLookup()">
          <mat-icon>search</mat-icon>
        </button>
      </div>

      <!-- Lookup Texto Adicional -->
      <div *ngIf="showTxtAddLookup" class="txtadd-lookup-panel">
        <div style="display:flex; align-items:center; gap:8px; margin-bottom:6px;">
          <mat-form-field style="flex:1" appearance="outline">
            <mat-label>Pesquisar texto adicional</mat-label>
            <input matInput [value]="txtAddSearch" (input)="onTxtAddSearchChange($event.target.value)" autocomplete="off" />
          </mat-form-field>
          <button mat-icon-button type="button" color="warn" matTooltip="Fechar" (click)="showTxtAddLookup = false">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="txtadd-lookup-list">
          <div *ngIf="txtAddLoading" style="text-align:center; padding:12px;">Carregando...</div>
          <div *ngIf="!txtAddLoading && txtAddResults.length === 0" style="text-align:center; padding:12px; color:#888;">
            Nenhum texto adicional encontrado
          </div>
          <table *ngIf="!txtAddLoading && txtAddResults.length > 0" class="txtadd-lookup-table">
            <thead>
              <tr>
                <th style="width:60px">Código</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of txtAddResults" (click)="selectTxtAdd(item)" class="txtadd-lookup-row"
                  matTooltip="{{ item.texto }}">
                <td>{{ (item.codigo ?? item.id)?.toString().padStart(5, '0') }}</td>
                <td>{{ item.descricao }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <textarea formControlName="message" rows="6"></textarea>
    </div>

    <!-- Checkbox 'enviar assunto' removido -->

    <div>
      <label>Anexos (mídia)</label>
      <input type="file" (change)="onFilesSelected($event)" multiple />
    </div>

    <div *ngIf="attachments.length">
      <h4>Anexos</h4>
      <ul>
        <li *ngFor="let a of attachments; let i = index">
          {{ a.name }} ({{ a.size }} bytes)
          <button type="button" (click)="removeAttachment(i)">Remover</button>
        </li>
      </ul>
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Fechar</button>
  <button mat-flat-button color="primary" (click)="send()" [disabled]="sending">
    <mat-progress-spinner *ngIf="sending" [diameter]="18" mode="indeterminate" class="sending-spinner"></mat-progress-spinner>
    {{ sending ? 'Enviando...' : 'Enviar' }}
  </button>
</div>
